(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    // Buy Now button - direct to checkout
  document.addEventListener('DOMContentLoaded', function() {
    let currentVariantPrice = null;
    
    // Store initial price from button data attribute
    const firstButton = document.querySelector('.buy-now-button');
    if (firstButton && firstButton.dataset.variantPrice) {
      currentVariantPrice = parseInt(firstButton.dataset.variantPrice);
    }
    
    function updateBuyNowPrice() {
      if (!currentVariantPrice) return;
      
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      
      const quantityInput = form.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      const totalPrice = (currentVariantPrice * quantity / 100).toFixed(2).replace(/\.00$/, '');
      
      const priceElements = document.querySelectorAll('[data-buy-now-price]');
      priceElements.forEach(function(el) {
        el.textContent = totalPrice + ' ₪';
      });
    }
    
    document.querySelectorAll('.buy-now-button').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const form = button.closest('form');
        if (!form) return;
        
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;
        
        const variantId = variantInput.value;
        const quantityInput = form.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? quantityInput.value : 1;
        
        // Direct to checkout
        window.location.href = '/cart/' + variantId + ':' + quantity + '?checkout';
      });
    });
    
    // Update price when variant changes - listen to theme's variant:update event
    document.addEventListener('variant:update', function(e) {
      const variant = e.detail.resource;
      if (!variant || !variant.price) return;
      
      currentVariantPrice = variant.price;
      updateBuyNowPrice();
    });
    
    // Update price when quantity changes
    document.addEventListener('quantity-selector:update', function(e) {
      updateBuyNowPrice();
    });
    
    // Also listen for direct input changes on quantity fields
    document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
      input.addEventListener('change', updateBuyNowPrice);
      input.addEventListener('input', updateBuyNowPrice);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
